<template>
    <div>
        <el-row class="toprow is-text-align-right" style="margin-bottom:10px">
            <el-select
                v-model="activeAllocationId"
                placeholder="Select"
                style="width: 300px"
            >
                <el-option
                    v-for="allocation in allocations"
                    :key="'liv' + allocation.id"
                    :label="
                        allocation.annee +
                            '/' +
                            (parseInt(allocation.annee) + 1).toString() +
                            ' - ' +
                            etats[allocation.etat]
                    "
                    :value="allocation.id"
                />
            </el-select>
        </el-row>
        <el-steps
            v-if="panier.etat"
            :active="paniersetat[panier.etat]['step']"
            align-center
            :process-status="paniersetat[panier.etat]['status']"
        >
            <el-step
                v-for="(etat, etatindex) in paniersetat"
                :title="etat.label"
                :key="'step' + etatindex"
                @click.native="e => clickHandler(e, etatindex)"
            />
        </el-steps>
        <el-table
            v-loading="loading"
            :data="panier.bouteilles"
            border
            fit
            highlight-current-row
            style="width: 100%"
        >
            <el-table-column align="left" label="Bouteille" prop="bouteille">
                <template slot-scope="scope">
                    <span v-if="scope.row.ismagnum">Magnum </span>
                    <span>{{ scope.row.vin.nom }} {{ scope.row.millesime }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="left"
                label="Qté"
                width="50"
                prop="quantite"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.pivot.quantite }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="right"
                label="Prix U."
                width="100"
                prop="prixu"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.prixttc }}€ ttc</span>
                </template>
            </el-table-column>
            <el-table-column
                align="right"
                label="Prix"
                width="100"
                prop="prixu"
            >
                <template slot-scope="scope">
                    <span
                        >{{
                            scope.row.prixttc * scope.row.pivot.quantite
                        }}€</span
                    >
                </template>
            </el-table-column>
        </el-table>
        <hr />
        <div class="is-text-align-right">
            Prix : {{ panier.totalBouteillesTTC }}€ ttc
        </div>
        <hr />
        <div v-if="panier.livraisonttc >= 0" class="is-text-align-right">
            Livraison : {{ panier.livraisonttc }}€ ttc
        </div>
        <div v-else class="is-text-align-right">
            Livraison : {{ panier.livraisonexp }}
        </div>
        <hr />
        <div class="is-text-align-right">
            Total : {{ panier.totalttc }}€ ttc
        </div>
        <hr />
        <div class="is-text-align-right">
            Calcul Livraison : {{ panier.livraisonexp }}
        </div>
        <hr />
        <div class="is-text-align-right">
            <el-button
                v-if="panier.etat == 'avalider'"
                type="danger"
                class="button"
                @click.native.prevent="handleNepasvalider()"
            >
                Ne pas valider et la remettre "en cours"
            </el-button>
             <el-button
                type="success"
                class="button"
                @click.native.prevent="$router.push('/editstock/' + userid)"
            >
                Modifier
            </el-button>
       </div>
        <el-dialog
            title="État commande"
            :visible.sync="dialogChangeEtat"
            :modal-append-to-body="true"
            :append-to-body="true"
            v-loading="changeEtatLoading"
        >
            <div class="form-container">
                Changer l'état de la commande à "{{
                    nouveletat ? paniersetat[nouveletat]["label"] : ""
                }}"
                <hr />
                <el-form ref="invitationForm" style="max-width: 600px;">
                    <el-form-item label="Notifier" prop="message">
                        <el-switch
                            v-model="avecnotification"
                            active-text="OUI"
                            inactive-text="NON"
                        />
                    </el-form-item>

                    <el-form-item
                        v-show="avecnotification"
                        label="Message"
                        prop="message"
                    >
                        <el-input type="textarea" :rows="3" v-model="message" />
                    </el-form-item>
                    <el-form-item
                        v-show="avecnotification"
                        label="fichiers"
                        prop="message"
                    >
                        <el-upload
                            ref="upload"
                            action=""
                            :multiple="true"
                            :auto-upload="false"
                            :on-change="addfile"
                        >
                            <el-button
                                slot="trigger"
                                size="small"
                                type="primary"
                            >
                                Choisir un ou des fichiers
                            </el-button>
                            <!--
                            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">Envoyer au serveur</el-button>
                            -->
                            <div class="el-upload__tip" slot="tip">
                                Fichiers PDF avec une taille inférieure à 500kb
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogChangeEtat = false">
                        Annuler
                    </el-button>
                    <el-button type="primary" @click="update()">
                        Valider
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Resource from "@/api/resource";
import { findoptions } from "@/utils/options";
const panierResource = new Resource("paniers");
const allocationResource = new Resource("allocations");

export default {
    name: "Adresses",
    props: {
        userid: {
            type: Number,
            default: 0
        },
        parent: {
            type: Object
        }
    },
    data() {
        return {
            options: {
                allocation_encours: "",
                allocation_avalider: "",
                allocation_valided: "",
                allocation_payed: "",
                allocation_livred: ""
            },
            allocations: null,
            activeAllocation: {},
            activeAllocationId: null,
            etats: {
                encours: "En cours",
                finalisee: "Finalisée",
                attente: "En attente"
            },
            panier: {},
            loading: false,
            loadingsteps: false,
            dialogChangeEtat: false,
            changeEtatLoading: false,
            message: "",
            nouveletat: "",
            files: [],
            avecnotification: true,
            // file: false,
            paniersetat: {
                encours: {
                    label: "En cours",
                    step: 0,
                    status: "process",
                    message: "allocation_encours"
                },
                avalider: {
                    label: "À Valider",
                    step: 1,
                    status: "success",
                    message: "allocation_avalider"
                },
                valided: {
                    label: "Validée",
                    step: 2,
                    status: "success",
                    message: "allocation_valided"
                },
                payed: {
                    label: "Payée",
                    step: 3,
                    status: "success",
                    message: "allocation_payed"
                },
                livred: {
                    label: "Livrée",
                    step: 4,
                    status: "success",
                    message: "allocation_livred"
                }
            }
        };
    },
    created() {
        findoptions(this.options, this, true);
        this.getAllocations();
    },
    mounted() {
        // this.getPanier();
    },
    watch: {
        dialogChangeEtat() {
            // console.log("dialogChangeEtat " + this.paniersetat[this.nouveletat]["message"] + " " + val);
            this.message = this.options[
                this.paniersetat[this.nouveletat]["message"]
            ];
        },
        activeAllocationId(val) {
            if (val && this.allocations) {
                this.activeAllocation = this.allocations.find(
                    allocation => allocation.id === val
                );
                console.log("cherche paniers ALLOCATION:");
                console.log(this.activeAllocationId);
                console.log(this.activeAllocation);

                this.getPanier(val);
            }
        }
    },
    computed: {},
    methods: {
        callbackoptions(slug, data) {
            this.options[slug] = data;
        },
        clickHandler(e, etat) {
            console.log("step");
            console.log(e);
            console.log(etat);
            this.nouveletat = etat;
            this.dialogChangeEtat = true;
            /*
            this.update({
                etat: etat
            });
            */
        },
        handleNepasvalider(){
            console.log("ne pas valider");
            this.nouveletat = "encours";
            this.dialogChangeEtat = true;
        },
        async getAllocations() {
            console.log("getAllocations");
            this.activeAllocation = null;
            this.activeAllocationId = null;
            this.loading = true;
            const { data } = await allocationResource.list({});
            this.allocations = data;
            this.activeAllocation = data[0];
            this.activeAllocationId = data[0].id;
            this.loading = false;
            console.log("ALLOCATIONS");
            console.log(this.allocations);
        },
        async getPanier(allocation_id) {
            console.log("getPanier");
            this.loading = true;
            const { data } = await panierResource.list({
                user_id: this.userid,
                allocation_id: allocation_id
            });
            if (data && data.etat) {
                this.panier = data;
            }
            this.loading = false;
            console.log("getPanierB");
            console.log(data);
        },
        addfile(file, fileList) {
            console.log("fileList");
            console.log(file);
            console.log(fileList);
            this.files = fileList;
            // this.file = file.raw;
        },
        update() {
            this.changeEtatLoading = true;
            /*
            var data = {
                etat: this.nouveletat,
                mailmessage: this.message
            }
            */

            const formData = new FormData();
            formData.append("etat", this.nouveletat);
            formData.append("mailmessage", this.message);
            var avecnotification = this.avecnotification ? 1 : 0;
            formData.append("avecnotification", avecnotification);
            // data.append('files[]', this.files);
            Array.from(this.files).forEach(function(file) {
                formData.append("files[]", file.raw);
            });
            // formData.append('file', this.file);

            panierResource
                .updatepost(this.panier.id, formData)
                .then(response => {
                    console.log(response);
                    this.loadingsteps = false;
                    this.panier = response.data;
                    this.$message({
                        message: "Allocation mise à jour",
                        type: "success",
                        duration: 3 * 1000
                    });
                    this.changeEtatLoading = false;
                    this.dialogChangeEtat = false;
                    // reset form
                    this.message = "";
                    this.files = [];
                    if(this.$refs.files){
                        this.$refs.files.clearFiles();
                    }
                })
                .catch(error => {
                    this.$message({
                        message: "Erreur de mise à jour",
                        type: "danger",
                        duration: 1 * 1000
                    });
                    console.log("error");
                    console.log(error.response);
                    this.loadingsteps = false;
                    this.changeEtatLoading = false;
                    this.dialogChangeEtat = false;
                    // reset form
                    this.message = "";
                    this.files = [];
                    if(this.$refs.files){
                        this.$refs.files.clearFiles();
                    }
                });
        }
    }
};
</script>
